export const config = {
    version: '5.0',
    build: (new Date()).getFullYear().toString() + (new Date()).getMonth().toString() + (new Date()).getDate().toString() + (new Date()).getHours().toString() + (new Date()).getMinutes().toString(),
    env: 'prod',
    apiAddress: 'https://api.andra-ai.com',
    theme: 'dark',
    imidServer: 'https://id.icymat.com/',
    imidOAuthId: 'b30d14349bf27ee4abb70064892436d0e5038875.apps.icymat.com',
    icymat_assistant: false,
    special_colors: null
};
